import React from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface PadletEmbedProps {
  url: string;
  title: string;
}

const PadletEmbed: React.FC<PadletEmbedProps> = ({ url, title }) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-4 text-left">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
        <h3 className="min-w-0 flex-1 text-base font-semibold leading-snug tracking-tight">
          {title}
        </h3>
        <Button
          asChild
          variant="outline"
          size="sm"
          className="w-fit shrink-0 border-border/80 bg-background/60 shadow-sm sm:mt-0.5"
        >
          <a href={url} target="_blank" rel="noopener noreferrer">
            <ExternalLink className="h-4 w-4 mr-2" />
            {t("Otevřít v Padletu", "Otvoriť v Padlete")}
          </a>
        </Button>
      </div>
      <div className="relative w-full overflow-hidden rounded-2xl border border-border/50 bg-muted/30 shadow-inner ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
        <iframe
          src={url}
          title={title}
          loading="lazy"
          referrerPolicy="no-referrer"
          allow="clipboard-write; fullscreen"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          className="h-[min(72vh,900px)] min-h-[480px] w-full sm:h-[70vh] sm:min-h-[500px]"
        />
      </div>
    </div>
  );
};

export default PadletEmbed;
